// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    aligment = "aligment",
    height = "height",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.aligment]: "flex-start" | "center" | "flexp-end";
        [fields.height]: string;
    };
}

export interface ContentPageHeaderStyles {
    title?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
}

export const contentPageHeaderStyles: ContentPageHeaderStyles = {
    title: {
        variant: "h1",
    },
    wrapper: {
        css: css`
            background: ${getColor("common.gradient1")};
            color: ${getColor("primary.contrast")};
            display: flex;
            align-items: center;
        `,
    },
    titleWrapper: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
            ${siteWidthStyles()}
        `,
    },
};

const styles = contentPageHeaderStyles;

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & OwnProps;

const ContentPageHeader: React.FC<Props> = ({ pageTitle, fields }) => {
    const titleWrapperStyles = {
        css: css`
            ${styles.titleWrapper?.css}
            justify-content: ${fields.aligment};
        `,
    };

    const wrapperStyles = {
        css: css`
            ${styles.wrapper?.css}
            height: ${fields.height}vh;
        `,
    };

    return (
        <StyledWrapper {...wrapperStyles}>
            <StyledWrapper {...titleWrapperStyles}>
                <Typography {...styles.title} data-test-selector="PageTitle">
                    {fields.overrideTitle || pageTitle}
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ContentPageHeader),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.aligment,
                displayName: "Title Aligment",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "flex-start" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "flex-end" },
                ],
                defaultValue: "center",
                hideEmptyOption: true,
            },
            {
                fieldType: "General",
                name: fields.height,
                displayName: "Banner Height",
                editorTemplate: "IntegerField",
                defaultValue: 19,
                tooltip: "The height is the percent of the viewport height.",
            },
        ],
    },
};

export default widgetModule;
